import { useTheme } from '@mui/material/styles';

const LIGHT = {
  green:    { color: '#15803d', bg: '#f0fdf4', border: '#dcfce7' },
  greenAlt: { color: '#15803d', bg: '#f0fdf4', border: '#bbf7d0' },
  red:      { color: '#b91c1c', bg: '#fef2f2', border: '#fee2e2' },
  redAlt:   { color: '#b91c1c', bg: '#fef2f2', border: '#fecaca' },
  amber:    { color: '#a16207', bg: '#fefce8', border: '#fef9c3' },
  amberAlt: { color: '#92400e', bg: '#fffbeb', border: '#fde68a' },
  blue:     { color: '#1d4ed8', bg: '#eff6ff', border: '#dbeafe' },
  blueAlt:  { color: '#1d4ed8', bg: '#eff6ff', border: '#bfdbfe' },
  blueDark: { color: '#1e40af', bg: '#eff6ff', border: '#bfdbfe' },
  zinc:     { color: '#71717a', bg: '#f4f4f5', border: '#e4e4e7' },
  zincAlt:  { color: '#71717a', bg: '#fafafa', border: '#e4e4e7' },
  purple:   { color: '#7c3aed', bg: '#f5f3ff', border: '#ede9fe' },
  teal:     { color: '#0f766e', bg: '#f0fdfa', border: '#ccfbf1' },
  tealAlt:  { color: '#0f766e', bg: '#f0fdfa', border: '#99f6e4' },
  cyan:     { color: '#155e75', bg: '#ecfeff', border: '#a5f3fc' },
  indigo:   { color: '#4f46e5', bg: '#eef2ff', border: '#c7d2fe' },
};

const DARK = {
  green:    { color: '#86efac', bg: 'rgba(21,128,61,0.15)', border: 'rgba(21,128,61,0.3)' },
  greenAlt: { color: '#86efac', bg: 'rgba(21,128,61,0.15)', border: 'rgba(21,128,61,0.35)' },
  red:      { color: '#fca5a5', bg: 'rgba(185,28,28,0.15)', border: 'rgba(185,28,28,0.3)' },
  redAlt:   { color: '#fca5a5', bg: 'rgba(185,28,28,0.15)', border: 'rgba(185,28,28,0.35)' },
  amber:    { color: '#fbbf24', bg: 'rgba(161,98,7,0.15)', border: 'rgba(161,98,7,0.3)' },
  amberAlt: { color: '#fbbf24', bg: 'rgba(146,64,14,0.15)', border: 'rgba(146,64,14,0.35)' },
  blue:     { color: '#93c5fd', bg: 'rgba(29,78,216,0.15)', border: 'rgba(29,78,216,0.3)' },
  blueAlt:  { color: '#93c5fd', bg: 'rgba(29,78,216,0.15)', border: 'rgba(29,78,216,0.35)' },
  blueDark: { color: '#93c5fd', bg: 'rgba(30,64,175,0.15)', border: 'rgba(30,64,175,0.35)' },
  zinc:     { color: '#a1a1aa', bg: 'rgba(113,113,122,0.15)', border: 'rgba(113,113,122,0.3)' },
  zincAlt:  { color: '#a1a1aa', bg: 'rgba(113,113,122,0.12)', border: 'rgba(113,113,122,0.3)' },
  purple:   { color: '#c4b5fd', bg: 'rgba(124,58,237,0.15)', border: 'rgba(124,58,237,0.3)' },
  teal:     { color: '#5eead4', bg: 'rgba(15,118,110,0.15)', border: 'rgba(15,118,110,0.3)' },
  tealAlt:  { color: '#5eead4', bg: 'rgba(15,118,110,0.15)', border: 'rgba(15,118,110,0.4)' },
  cyan:     { color: '#67e8f9', bg: 'rgba(21,94,117,0.15)', border: 'rgba(21,94,117,0.3)' },
  indigo:   { color: '#a5b4fc', bg: 'rgba(79,70,229,0.15)', border: 'rgba(79,70,229,0.3)' },
};

export function useStatusPalette() {
  const theme = useTheme();
  return theme.palette.mode === 'dark' ? DARK : LIGHT;
}

export function statusPaletteFor(mode) {
  return mode === 'dark' ? DARK : LIGHT;
}
